import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=567bea79&scoped=true&"
import script from "./ViewHeader.vue?vue&type=script&lang=js&"
export * from "./ViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewHeader.vue?vue&type=style&index=0&id=567bea79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bea79",
  null
  
)

export default component.exports